// CenteredMessage.js

import React from 'react';
import './CenteredMessage.css'; // Make sure to create this CSS file in the same directory

const CenteredMessage = () => {
  return (
    <div className="centered-message-container">
      <div className="centered-message-content">
        <h1>Nothing here yet, check Designs page for more awesomeness</h1>
      </div>
    </div>
  );
};

export default CenteredMessage;
